<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Quản lý thiết bị cho mượn và đổi trả</h1>
      <div class="float-right btn-group">
        <DraggableTable
          :naming="$route.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
        <b-button
          variant="outline-secondary"
          @click="handleExport"
          class="font-medium f12 no-padding"
        >
          <i class="bx bx-download"></i> Xuất file
        </b-button>
      </div>
    </div>

    <div class="p-10 card pt-15 b-t-1-869fb229">
      <FilterLendDevice ref="filterLendDeviceRef" @change="handleFilter" />

      <div class="card-body">
        <div class="p-10">
          <p>
            <span class="text-muted">Tổng số: </span> {{ total }}
            <span v-for="(type, index) in listCountDevice" :key="index">
              <span class="text-muted"> | {{ mapTextStatusIDLend[type.status] }}: </span>
              <b :class="`text-${mapVariantStatusIDLend[type.status]}`">{{ type.count }}</b>
            </span>
          </p>

          <div class="table-responsive">
            <b-table
              :busy.sync="isTableLoading"
              sticky-header="600px"
              hover
              :items="listData"
              :fields="filterTable"
              bordered
              show-empty
              responsive
              class="nowrap-table"
              style="min-width: 100%"
            >
              <template #table-busy>
                <div class="my-2 text-center">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>

              <template #empty>
                <div class="text-center text-info my-2">Không có dữ liệu</div>
              </template>

              <!-- Cột STT -->
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>

              <!-- Cột ID cho mượn -->
              <!-- <template #cell(lendingId)="data">
                {{ data.item.lendingId }}
              </template> -->

              <!-- Cột Thông tin MC -->
              <template #cell(MCInfor)="data">
                <p><span class="text-muted">Tên: </span>{{ data.item.merchantName }}</p>
                <p><span class="text-muted">Email: </span>{{ data.item.merchantEmail }}</p>
                <p><span class="text-muted">Mã HĐ: </span> {{ data.item.contractCode }}</p>
                <p>
                  <span class="text-muted">Ngày mượn: </span
                  >{{ data.item.lendingStartTime | formatDate }}
                </p>
              </template>

              <!-- Cột Mã serial -->
              <template #cell(serial)="data">
                <p>
                  <span class="text-muted">Tên thiết bị: </span>{{ data.item.deviceCategoryName }}
                </p>
                <p><span class="text-muted">Serial: </span>{{ data.item.deviceSerial }}</p>
                <p><span class="text-muted">Tên kho: </span>{{ data.item.inventoryName }}</p>
                <p>
                  <span class="text-muted">Vùng: </span>
                  <span v-for="(region, index) in data.item.regionNames || []" :key="index">
                    {{ region }}
                    <span v-if="index < (data.item.regionNames || []).length - 1">,</span>
                  </span>
                </p>
              </template>

              <!-- Cột Phiếu thu -->
              <template #cell(receiptNum)="data">
                <p><span class="text-muted">Mã phiếu: </span>{{ data?.item?.receiptCode }}</p>
                <p>
                  <span class="text-muted">Ngày tạo: </span
                  >{{ data?.item?.receiptCreatedTime | formatDate }}
                </p>
                <p>
                  <span class="text-muted">Cọc: </span
                  >{{ data.item?.depositAmount | fomatCurrency }}
                </p>
                <p>
                  <span class="text-muted">Trạng thái: </span>
                  <b-badge
                    v-if="data?.item?.receiptStatus"
                    :variant="mapVariantReceiptStatus[data.item?.receiptStatus] ?? 'primary'"
                  >
                    {{ mapTextReceiptStatus[data?.item?.receiptStatus] ?? 'Chưa thu tiền' }}
                  </b-badge>
                </p>
              </template>

              <!-- Cột Phiếu hoàn tiền / Thu thêm -->
              <template #cell(refund)="data">
                <p><span class="text-muted">Phiếu hoàn: </span>{{ data.item.refundCode }}</p>
                <p>
                  <span class="text-muted">Ngày hoàn: </span
                  >{{ data.item.refundCreatedTime | formatDate }}
                </p>
                <p>
                  <span class="text-muted">Trạng thái: </span
                  ><b-badge :variant="mapVariantStatusRefund[data.item.refundStatus] ?? 'primary'">
                    {{ mapTextStatusRefund[data.item.refundStatus] ?? '' }}
                  </b-badge>
                </p>
              </template>

              <!-- Cột Số tiền -->
              <!-- <template #cell(fee)="data">
                <p>
                  <span class="text-muted">Cọc: </span>{{ data.item.depositAmount | fomatCurrency }}
                </p>
                <p>
                  <span class="text-muted">Khấu hao: </span
                  >{{ data.item.additionalCollectionAmount | fomatCurrency }}
                </p>
                <p>
                  <span class="text-muted">Hoàn cọc: </span
                  >{{ data.item.refundAmount | fomatCurrency }}
                </p>
              </template> -->

              <!-- Cột TPV tháng T-2 -->
              <template #cell(TPVT2)="data">
                <div
                  v-if="data?.item?.statusTpvMonthTMinus2 !== 'SKIPPED'"
                  style="display: flex; justify-content: center; flex-direction: column"
                >
                  <p class="text-left">
                    <span class="text-muted">TPV: </span
                    >{{ data.item.tpvMonthTMinus2 | fomatCurrency }}
                  </p>
                  <p>
                    <span class="text-muted">SLGD: </span
                    >{{ (data.item.transactionMonthTMinus2 || 0) | transformNumber }}
                  </p>
                  <b-badge
                    :variant="mapVariantTPVStatus[data.item.statusTpvMonthTMinus2] ?? 'primary'"
                  >
                    {{ mapTextTPVStatus[data.item.statusTpvMonthTMinus2] ?? '' }}
                  </b-badge>
                </div>
              </template>

              <!-- Cột TPV tháng T-1 -->
              <template #cell(TPVT1)="data">
                <div
                  style="display: flex; justify-content: center; flex-direction: column"
                  v-if="data?.item?.statusTpvMonthTMinus1 !== 'SKIPPED'"
                >
                  <p class="text-left">
                    <span class="text-muted">TPV: </span
                    >{{ data.item.tpvMonthTMinus1 | fomatCurrency }}
                  </p>
                  <p>
                    <span class="text-muted">SLGD: </span
                    >{{ (data.item.transactionMonthTMinus1 || 0) | transformNumber }}
                  </p>

                  <b-badge
                    :variant="mapVariantTPVStatus[data.item.statusTpvMonthTMinus1] ?? 'primary'"
                  >
                    {{ mapTextTPVStatus[data.item.statusTpvMonthTMinus1] ?? '' }}
                  </b-badge>
                </div>
              </template>

              <!-- Cột TPV tháng T -->
              <template #cell(TPVT)="data">
                <p class="text-left">
                  <span class="text-muted">TPV: </span>{{ data.item.tpvMonthT | fomatCurrency }}
                </p>
                <p>
                  <span class="text-muted">SLGD: </span
                  >{{ (data.item.transactionMonthT || 0) | transformNumber }}
                </p>
              </template>

              <!-- Cột Trạng thái ID cho mượn -->
              <template #cell(StatusIDLend)="data">
                <b-badge :variant="mapVariantStatusIDLend[data.item.status] ?? 'primary'">
                  {{ mapTextStatusIDLend[data.item.status] ?? '' }}
                </b-badge>
                <div v-if="data.item.returnReason" class="text-center">
                  <span class="text-muted">Lý do: </span>
                  {{ data.item.returnReason }}
                </div>
              </template>

              <!-- Cột Thao tác -->
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="handleTriggerDetail(data.item.lendingId)"
                  >
                    <b-icon icon="eye" class="mb-1" /> Chi tiết
                  </b-dropdown-item>
                  <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="handleShowChart(data.item)"
                  >
                    <b-icon icon="eye" class="mb-1" /> Chi tiết TPV
                  </b-dropdown-item>
                  <!-- <b-dropdown-item
                    type="button"
                    class="dropdown-item"
                    @click="handleSyncTPV(data.item)"
                  >
                    <b-icon icon="arrow-repeat" class="mb-1" /> Đồng bộ TPV
                  </b-dropdown-item> -->
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div class="d-flex justify-content-end">
        <b-form-group class="mb-0" style="padding: 17px">
          <b-form-select
            v-model="fieldsSearch.limit"
            :options="pageOptions"
            @change="onItemsPerPageChange"
          ></b-form-select>
        </b-form-group>
        <b-pagination
          class="mr-2 fl-right"
          v-model="fieldsSearch.page"
          :total-rows="total"
          :per-page="fieldsSearch.limit"
          @change="onChangePage"
        ></b-pagination>
      </div>
    </div>
    <TransactionChartModal ref="transactionChartModalRef" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true" />
  </div>
</template>

<script>
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { showMess } from '@/config/utils'
  import { DeviceService } from '@/services/device.service'
  import moment from 'moment'

  import FilterLendDevice from './components/FilterLendDevice.vue'
  import TransactionChartModal from './components/TransactionChartModal.vue'

  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    {
      key: 'lendingId',
      label: 'ID cho mượn',
    },
    {
      key: 'MCInfor',
      label: 'Thông tin MC',
    },
    { key: 'serial', label: 'Thông tin thiết bị', class: 'text-center' },
    // { key: 'warehouseName', label: 'Kho' },
    // { key: 'contractNum', label: 'Số HĐ/PL' },
    { key: 'receiptNum', label: 'Phiếu thu', class: 'text-center' },
    // { key: 'refund', label: 'Phiếu hoàn tiền / Thu thêm' },
    // { key: 'fee', label: 'Số tiền', class: 'text-right' },
    { key: 'TPVT2', label: 'TPV tháng T-2', class: 'text-center' },
    { key: 'TPVT1', label: 'TPV tháng T-1', class: 'text-center' },
    { key: 'TPVT', label: 'TPV tháng T', class: 'text-center' },
    { key: 'StatusIDLend', label: 'Trạng thái ID cho mượn', class: 'text-center' },
    { key: 'action', label: 'Thao tác', class: 'text-center' },
  ]

  const searchFieldDefault = Object.freeze({
    page: 1,
    limit: 20,
  })

  const pageOptions = [
    { value: 20, text: '20/trang' },
    { value: 50, text: '50/trang' },
    { value: 100, text: '100/trang' },
    { value: 200, text: '200/trang' },
  ]

  export default {
    components: {
      FilterLendDevice,
      TransactionChartModal,
    },
    data() {
      return {
        isTableLoading: false,
        showLoading: false,
        listData: [],
        total: null,
        listCountDevice: [],
        fieldsTable,
        filterTable: fieldsTable,
        Config,
        fieldsSearch: cloneDeep(searchFieldDefault),
        pageOptions,
      }
    },
    computed: {
      mapTextTPVStatus() {
        return Config.statusTpv.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantTPVStatus() {
        return Config.statusTpv.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      mapTextReceiptStatus() {
        return Config.receiptStatus.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantReceiptStatus() {
        return Config.receiptStatus.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      mapTextStatusRefund() {
        return Config.statusRefund.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantStatusRefund() {
        return Config.statusRefund.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
      mapTextStatusIDLend() {
        return Config.statusIDLend.reduce((acc, item) => {
          acc[item.id] = item.text
          return acc
        }, {})
      },
      mapVariantStatusIDLend() {
        return Config.statusIDLend.reduce((acc, item) => {
          acc[item.id] = item.variant
          return acc
        }, {})
      },
    },
    async mounted() {
      await this.fetchData()
    },
    methods: {
      handleTriggerDetail(id) {
        window.open(`/detail-lend-device/${id}`)
      },
      handleShowChart(data) {
        const {
          deviceSerial,
          merchantId,
          merchantName,
          merchantEmail,
          deviceCategoryName,
          tpvConfig,
        } = data
        const toDate = moment().format('YYYY-MM')
        const fromDate = moment().subtract(12, 'months').format('YYYY-MM')
        const payload = {
          serials: [deviceSerial],
          merchantMnpIds: [merchantId],
          fromDate,
          toDate,
          reportType: 'MONTHLY',
          merchantName,
          merchantEmail,
          deviceName: deviceCategoryName,
          threshold: tpvConfig ?? 0,
        }
        this.$refs.transactionChartModalRef.openModal(payload)
      },
      async handleSyncTPV(data) {
        try {
          const { lendingId: id } = data
          this.showLoading = true
          const res = await DeviceService.syncTPVLendDevice({ id })
          if (res.code === 1000) {
            this.handleShowChart(data)
          } else {
            this.showFailMx(res.message)
          }
        } catch (error) {
          this.showFailMx(error.message)
        } finally {
          this.showLoading = false
        }
      },
      async onChangePage(page) {
        this.fieldsSearch.page = page
        await this.fetchData()
      },
      async onItemsPerPageChange() {
        this.fieldsSearch.page = 1
        await this.fetchData()
      },
      async handleFilter(payload) {
        this.fieldsSearch = {
          page: 1,
          limit: this.fieldsSearch.limit,
          ...payload,
        }
        await this.fetchData()
      },
      getIndex(index) {
        return (this.fieldsSearch.page - 1) * this.fieldsSearch.limit + index + 1
      },

      async handleExport() {
        showMess(
          this,
          'Thông báo',
          'Chức năng đang được phát triển',
          'warning',
          'b-toaster-top-right',
          3000
        )
      },
      async fetchData() {
        const body = { ...this.fieldsSearch }
        try {
          this.isTableLoading = true
          const res = await DeviceService.getListLendDevice(body)
          if (res.code === 1000) {
            this.total = res.data.count
            this.listCountDevice = res.data.totalDevices
            this.listData = res.data.deviceLendings
          } else {
            showMess(this, 'Error', res.message, 'danger', 'b-toaster-top-right', 3000)
          }
        } catch (error) {
          showMess(
            this,
            'Error',
            error.response?.data?.message || error.response?.message || error.message,
            'danger',
            'b-toaster-top-right',
            3000
          )
        } finally {
          this.isTableLoading = false
        }
      },
    },
  }
</script>

<style scoped>
  .nowrap-table {
    width: 100%;
    margin-bottom: 0;
  }

  .nowrap-table ::v-deep td {
    white-space: nowrap;
    padding: 0.5rem;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .nowrap-table ::v-deep td.break-word {
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: anywhere;
  }

  .nowrap-table ::v-deep th {
    white-space: nowrap !important;
    position: sticky;
    top: 0;
    z-index: 1;
  }

  .nowrap-table ::v-deep p {
    margin-bottom: 0.25rem;
  }

  .nowrap-table ::v-deep p:last-child {
    margin-bottom: 0;
  }

  .action-h {
    height: 41px;
  }
</style>
